import PeerAnalyserError from '../../../components/error-states/PeerAnalyserError'

/** Full-screen "Something went wrong" for elite-plans pages when a status API fails. */
export function ElitePlansStatusErrorScreen({ themeId, onRetry }: { themeId: string; onRetry: () => void }) {
  return (
    <div className='elite-plans-root flex h-screen flex-col' data-plan={themeId}>
      <div className='flex-1 min-h-0 px-5'>
        {/* Inner positioned box so PeerAnalyserError's absolute Retry button is inset by px-5 */}
        <div className='relative h-full'>
          <PeerAnalyserError onRetry={onRetry} />
        </div>
      </div>
    </div>
  )
}
